import React from "react";
import {
    Column,
    DataGrid,
    Sorting,
    Paging,
    Pager,
    LoadPanel,
    ColumnHeaderFilter,
    Selection,
} from "devextreme-react/data-grid";
class LookUpLocationGrid extends React.Component {
    constructor(props) {
        super(props);
        this.selectionChanged = this.selectionChanged.bind(this);
    }
    selectionChanged = ({ selectedRowsData }) => {
        const selectedData = selectedRowsData[0];
        if (selectedRowsData.length === 1) 
            this.props.parentCallback(selectedData.locationcode);
    };
    render() {
        return (
            <div>
                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                    noDataText="No Data"
                    dataSource={this.props.databanck}
                    showBorders={true}
                    className={this.props.selectedItems?.length>0?"Popup-GridHeightAccordianOpen":"Popup-GridHeightAccordianClose"}
                    hoverStateEnabled={true}
                    allowColumnResizing={true}
                    allowColumnReordering={false}
                    rowAlternationEnabled={false}
                    onSelectionChanged={(e) => this.selectionChanged(e)}
                    focusedRowEnabled={true}
                    showRowLines={true}
                    showColumnLines={false}
                    keyExpr={"rowid"}
                >
                    <ColumnHeaderFilter />
                    <LoadPanel enabled={true} />
                    <Selection mode="single" />
                    <Paging defaultPageSize={10} />
                    <Sorting visible={false} />
                    <Pager
                        visible={true}
                        showPageSizeSelector={true}
                        allowedPageSizes={[10, 20, 50, 500, 1000, "all"]}
                        showNavigationButtons={true}
                    />
                    <Column dataField="locationcode" caption="Location"></Column>
                    <Column dataField="locationdescription" caption="Description"></Column>
                    <Column dataField="locationtype" caption="Location Type"></Column>
                </DataGrid>
            </div>
        );
    }
}
export default LookUpLocationGrid;